import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {Button, Container, Heading, Text} from "@chakra-ui/react";
import usePageTitle from "../usePageTitle";

function NotFound() {
    usePageTitle("Page not found");
    return (
        <Container maxW="container.md" py={{base: 20, md: 32}} textAlign="center">
            <Text fontFamily="heading" fontWeight={700} fontSize="6xl" color="brand.500" lineHeight={1}>404</Text>
            <Heading as="h1" mt={4} textTransform="uppercase" fontSize={{base: "2xl", md: "3xl"}}>Page not found</Heading>
            <Text mt={4} color="ink.500">The page you are looking for has moved or no longer exists.</Text>
            <Button as={RouterLink} to="/" mt={8} size="lg">Back to home</Button>
        </Container>
    );
}

export default NotFound;
